module.exports = __webpack_public_path__ + "media/images/new/filter_by_reported_cell_service_laptop@2x-85df5144230d3ca4ae79fdf1cbea7cb3.png";